module.exports = __webpack_public_path__ + "static/media/homepage_service_banner.b50a1693.jpg";